import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "How long do braids last?",
    a: "Most braiding styles at Afro Magic last between 4 to 8 weeks with proper care. Knotless braids and box braids typically hold for 6-8 weeks, while cornrows and men's styles last 2-4 weeks. We recommend sleeping with a satin bonnet and moisturizing your scalp regularly to extend the life of your braids.",
  },
  {
    q: "Where is the best place for boho braids in Southfield?",
    a: "Afro Magic Braiding Hair at 22560 Telegraph Rd is Southfield's top destination for boho braids. Our boho braids blend feed-in braids with loose, curly ends for that effortless bohemian look — starting at $210. Book online in under a minute — only a $25 deposit secures your appointment.",
  },
  {
    q: "How much does hair braiding cost in Southfield, Michigan?",
    a: "Prices at Afro Magic range from $50 for cornrows and men's styles up to $300 for small butt-length goddess braids. Knotless braids start at $180, box braids at $180, and Fulani braids at $180. We offer transparent pricing with no hidden fees — a $25 deposit secures your online booking.",
  },
  {
    q: "Do I need an appointment or can I walk in?",
    a: "We welcome both! Walk-ins are accepted from 9 AM to 9 PM based on availability. Between 9 PM and 9 AM, service is by appointment only. We highly recommend booking online to secure your preferred date and time. A $25 refundable deposit is required for online bookings.",
  },
  {
    q: "What protective braiding styles do you offer for natural hair?",
    a: "We specialize in protective styles that keep your natural hair healthy while looking stunning. Our offerings include knotless braids, box braids, fulani braids, boho braids, kinky twists, faux locs, crochet styles, and sew-ins. Each style is designed to minimize tension and promote hair growth.",
  },
  {
    q: "How do I get to Afro Magic Braiding Hair?",
    a: "We are located at 22560 Telegraph Rd, Southfield, MI 48033 — right near the intersection of Telegraph Rd and Northwestern Hwy. We are easily accessible from Detroit, Farmington Hills, Oak Park, Lathrup Village, and the greater Oakland County area. Call us at (313) 484-7307 for directions.",
  },
  {
    q: "What is the best braiding salon near Detroit?",
    a: "Afro Magic Braiding Hair in Southfield is just minutes from Detroit via I-696 or Telegraph Rd. We are one of the highest-rated African hair braiding salons in Metro Detroit, offering over 20 professional braiding services. Many of our Detroit clients choose us for our quality, competitive pricing, and easy online booking.",
  },
  {
    q: "Do you serve clients from Farmington Hills, Troy, and Oakland County?",
    a: "Absolutely! We proudly serve the entire Oakland County area including Farmington Hills, Troy, Pontiac, Bloomfield Hills, West Bloomfield, Novi, Rochester Hills, Royal Oak, and beyond. Our salon at 22560 Telegraph Rd is centrally located and easy to reach from anywhere in Oakland County.",
  },
  {
    q: "Can I get knotless braids in Michigan?",
    a: "Yes! Afro Magic Braiding Hair is Michigan's premier destination for knotless braids. Our tension-free feed-in technique delivers a natural, seamless finish that's lighter on your scalp. Starting at $180. Clients drive from across Michigan — Detroit, Ann Arbor, Flint, Lansing — for our knotless braids.",
  },
];

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-brand-border">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-4 text-left group"
        data-testid={`faq-toggle-${q.slice(0, 20).replace(/\s/g, "-").toLowerCase()}`}
      >
        <span className="font-sans text-sm text-brand-text pr-4 group-hover:text-brand-gold transition-colors">
          {q}
        </span>
        <ChevronDown
          size={16}
          className={`text-brand-gold flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <p className="font-sans text-sm text-brand-text-muted pb-4 leading-relaxed">
          {a}
        </p>
      )}
    </div>
  );
};

const LocalExpertiseSection = () => {
  return (
    <section className="py-20 md:py-28 border-t border-brand-border" data-testid="local-expertise-section">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        {/* SEO Heading */}
        <h2 className="font-serif text-2xl md:text-3xl text-brand-text mb-10 text-center">
          Southfield's Premier African Hair Braiding Salon
        </h2>

        {/* 3 SEO Paragraphs */}
        <div className="space-y-6 mb-16">
          <p className="font-sans text-sm md:text-base text-brand-text-muted leading-relaxed">
            <strong className="text-brand-text">Premium Knotless Braids in Southfield, MI</strong> — Afro Magic Braiding Hair has earned its reputation as the go-to salon for knotless braids in the Southfield area. Our tension-free feed-in technique delivers a natural, seamless finish that's lighter on your scalp and lasts up to 8 weeks. Whether you prefer small, medium, or jumbo knotless braids, our experienced stylists customize every install to complement your face shape and personal style. Starting at $180, premium knotless braids have never been more accessible.
          </p>

          <p className="font-sans text-sm md:text-base text-brand-text-muted leading-relaxed">
            <strong className="text-brand-text">Top-rated African Hair Braiding near Northwestern Hwy</strong> — Located at 22560 Telegraph Rd, just minutes from the Northwestern Hwy corridor, Afro Magic is one of the highest-rated braiding salons in Southfield. We offer over 20 professional braiding services including box braids, fulani braids, boho braids, kinky twists, faux locs, crochet styles, and men's braiding. Our clients drive from across Metro Detroit, Farmington Hills, and Windsor, Ontario because of our attention to detail, fair pricing, and welcoming atmosphere. Walk-ins are always welcome, but online appointments guarantee your spot.
          </p>

          <p className="font-sans text-sm md:text-base text-brand-text-muted leading-relaxed">
            <strong className="text-brand-text">Professional Braiding Services for the Oakland County area</strong> — Whether you live in Southfield, Royal Oak, Troy, Pontiac, or anywhere in Oakland County, Afro Magic Braiding Hair offers the protective braiding styles your natural hair deserves. From quick cornrow touch-ups starting at $50 to show-stopping waist-length kinky twists, our full service menu is designed for every budget and lifestyle. We proudly serve as Oakland County's trusted braiding destination — a place where every braid is magic and every client leaves feeling beautiful.
          </p>
        </div>

        {/* FAQ Section */}
        <div>
          <h3 className="font-serif text-xl md:text-2xl text-brand-text mb-6 text-center">
            Frequently Asked Questions
          </h3>

          {/* FAQ Schema */}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              }),
            }}
          />

          <div className="max-w-3xl mx-auto" data-testid="faq-list">
            {faqs.map((f) => (
              <FaqItem key={f.q} q={f.q} a={f.a} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalExpertiseSection;
